(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('DeliveryDetailController', DeliveryDetailController);

    DeliveryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Delivery', 'Contract'];

    function DeliveryDetailController($scope, $rootScope, $stateParams, previousState, entity, Delivery, Contract) {
        var vm = this;

        vm.delivery = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ccsTrApp:deliveryUpdate', function(event, result) {
            vm.delivery = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
